module.exports = __webpack_public_path__ + "img/404@2x.bb8093b1.png";